import request from '@/utils/request'

/**
 * 新闻中心相关接口
 */
export const newsApi = {
  // 获取新闻中心列表
  getNewsCenterList(params = {}) {
    return request({
      url: '/getNewsCenterList',
      method: 'get',
      params: {
        page: 1,
        pageSize: 10,
        lan: 'hk', // 语言参数：zh中文, en英文, hk繁体中文
        ...params
      }
    })
  }
}

/**
 * 社会影响相关接口
 */
export const socialImpactApi = {
  // 获取社会影响列表
  getSocialImpactList(params = {}) {
    return request({
      url: '/getSocialImpactList',
      method: 'get',
      params: {
        page: 1,
        pageSize: 10,
        ...params
      }
    })
  }
}

// 导出所有API
export default {
  newsApi,
  socialImpactApi
}